"use strict";

exports.__esModule = true;
exports.YAxisDomainFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _styles = require("./styles");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var YAxisDomainFields = exports.YAxisDomainFields = function YAxisDomainFields(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  var _element$props = element.props,
    minYValue = _element$props.minYValue,
    maxYValue = _element$props.maxYValue,
    enableYDomain = _element$props.enableYDomain;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.YAxisDomainFieldsHeader, null, translate("YAxisDomainFields.label", "Custom Y-Axis")), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: "15px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "enable/disable-y-domain-switch",
    label: translate("YAxisDomainFields.switch.label", "Enable/Disable"),
    checked: enableYDomain || false,
    onChange: function onChange() {
      elementEditor.setProp(path, "enableYDomain", !enableYDomain);
    }
  }), /*#__PURE__*/_react["default"].createElement(_styles.AxisControls, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("YAxisDomainFields.minInput.label", "Min Value")
  }, /*#__PURE__*/_react["default"].createElement(_styles.MinMaxNumericInput, {
    "data-testid": "min-y-value-field",
    value: minYValue,
    max: maxYValue,
    disabled: !enableYDomain,
    onValueChange: function onValueChange(_minYValue) {
      return elementEditor.setProp(path, "minYValue", _minYValue);
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    style: {
      paddingLeft: "30px"
    },
    label: translate("YAxisDomainFields.maxInput.helperText", "Max Value")
  }, /*#__PURE__*/_react["default"].createElement(_styles.MinMaxNumericInput, {
    "data-testid": "max-y-value-field",
    value: maxYValue,
    min: minYValue,
    disabled: !enableYDomain,
    onValueChange: function onValueChange(_maxYValue) {
      return elementEditor.setProp(path, "maxYValue", _maxYValue);
    }
  })))));
};